import React from "react";
import PropTypes from "prop-types";
import { Accordion, Button, Card, Col, Row } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import VoteCounter from "./VoteCounter";
import FAQEditorModal from "./FAQEditorModal";
import RemoveFaqVarificationModal from "./RemoveFaqVarificationModal";

export default function QandA(props) {
  return (
    <Card>
      <Card.Header>
        <Row>
          <Col>
            <strong>Question: {props.question.question}</strong>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col xs="auto">
            <VoteCounter
              id={props.question.questionId}
              voteClick={voteClick}
              voteCount={props.question.usefulnessScore}
            />
          </Col>
          <Col>
            <ReactMarkdown source={props.question.answer} />
          </Col>
          {props.isAdmin ? (
            <Col xs="auto">
              <Row>
                <FAQEditorModal
                  key={`editButton${props.question.questionId}`}
                  question={props.question}
                />
              </Row>
              <Row>
                <RemoveFaqVarificationModal questionId={props.question.questionId} />
              </Row>
            </Col>
          ) : null}
        </Row>
        {props.question.details && props.question.details.trim().length > 0 ? (
          <Accordion>
            <Row className="justify-content-center">
              <Col xs="auto">
                <Accordion.Toggle
                  as={Button}
                  eventKey={props.eventKey}
                  size="sm"
                  variant="outline-info"
                >
                  More Details
                </Accordion.Toggle>
              </Col>
            </Row>
            <Accordion.Collapse eventKey={props.eventKey}>
              <Card.Body>
                <ReactMarkdown source={props.question.details} />
              </Card.Body>
            </Accordion.Collapse>
          </Accordion>
        ) : null}
      </Card.Body>
    </Card>
  );

  function voteClick(scoreChange) {
    props.onVoteClick(props.question.questionId, scoreChange);
  }
}

QandA.propTypes = {
  isAdmin: PropTypes.bool.isRequired,
  onVoteClick: PropTypes.func.isRequired,
  question: PropTypes.object.isRequired
};
